import { ASK_QUESTION_KEY } from '@atlassian/conversation-assistant-message-actions-api/constants';
import { type StoreChatItem } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { getLastAssistantActions } from './getLastAssistantActions';

export function lastAssistantHasAskQuestionAction(messages: StoreChatItem[]): boolean {
	return getLastAssistantActions(messages).some((action) => action.key === ASK_QUESTION_KEY);
}
